import Button from 'components/shared/Button.styled';
import { Heading3 } from 'components/shared/Typography.styled';
import styled from 'styled-components';
import { getPublicPath } from 'utils/paths';
import { color, fontWeight, radius, spacing } from '../../../../theme';

export const StyledCta = styled.aside`
  position: absolute;
  bottom: 0;
  background-color: ${color('midnight_900')};
  border-radius: ${radius('lg')};
  padding: ${spacing('xl4')} ${spacing('lg')} ${spacing('lg')};
  color: ${color('text_default_inverse')};
  font-weight: ${fontWeight('medium')};
  line-height: 1.25;
  background-image: ${() =>
    `url('${getPublicPath('/images/blog/floating-cta-bg.svg')}')`};
  background-size: contain;
  background-position: center center;
  background-repeat: no-repeat;

  max-width: 400px;

  &::before {
    content: '';
    width: 204px;
    height: 173px;
    position: absolute;
    top: 0;
    left: 50%;
    transform: translate(-50%, -60%);
    background-image: ${() =>
      `url('${getPublicPath('/images/blog/floating-cta-image.svg')}')`};
  }

  ${Button} {
    position: absolute;
    top: ${spacing('xs')};
    right: ${spacing('xs')};
  }

  ${Heading3} {
    &::before {
      left: 0;
      transform: unset;
    }
  }
`;
